import {rpAppLink} from "@pg-mono/rp-routes";

import {setCreditFiltersStorage} from "./credit_storage";

export const redirectToCreditOffers = (price: number, contribution: number, period: number) => {
    setCreditFiltersStorage({
        price,
        contribution: Math.round((contribution * price) / 100),
        period,
        credit_amount: Math.round(price - contribution)
    });

    window.open(rpAppLink.credits.offers(), "_blank");
};
import {rpAppLink} from "@pg-mono/rp-routes";

import {setCreditFiltersStorage} from "./credit_storage";

export const redirectToCreditOffers = (price: number, contribution: number, period: number) => {
    setCreditFiltersStorage({
        price,
        contribution: Math.round((contribution * price) / 100),
        period,
        credit_amount: Math.round(price - contribution)
    });

    window.open(rpAppLink.credits.offers(), "_blank");
};
